import 'leaflet.markercluster'
import 'leaflet.markercluster/dist/MarkerCluster.css'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'

import {createPathComponent} from '@react-leaflet/core'
import {IMarkerClusterGroupInstance, LeafletClusterProps} from "@ui/leafletCustom/leafletCluster/types";
import {updateMarkerCluster} from "@ui/leafletCustom/leafletCluster/updateCluster";
import {createMarkerCluster} from "@ui/leafletCustom/leafletCluster/createCluster";


const LeafletCluster = createPathComponent<IMarkerClusterGroupInstance, LeafletClusterProps>(createMarkerCluster, updateMarkerCluster)

export default LeafletCluster;